import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Title from '../../shared/Title';
import FFPaper from '../../shared/FFPaper';
import FFLinearProgress from '../../shared/FFLinearProgress';
import MultipleDropDownMenu from '../../shared/MultipleDropDownMenu';
import KebabMenu, { defaultMenus } from '../../shared/KebabMenu';
import { QualityStoreValue } from '../../../model/enrollment';
import { useTranslation } from 'react-i18next';

const handler = (menu: string) => {
     console.log(menu);
}

export interface QualityScoreProps {
    data?: QualityStoreValue;
}

export default function QualityScoreCard({ data }: QualityScoreProps ) {
    const { t } = useTranslation();
    
    const itemList: any[] = !data ? [] : Object.entries(data.value).map(([metric, val], i) => {
        const parsedValue = Number(val.replace('%',''));
        const camelCaseMetric = metric[0].toUpperCase() + metric.substring(1);

        return <Stack key={i} direction="row" spacing={3} sx={{ alignItems: 'center' }}>
            <Typography color="secondary" fontSize={14} sx={{ flex: '1 0 30%', pl: 2 }}>{camelCaseMetric}</Typography>
            <Stack direction="row" sx={{ flex: '1 0 70%', pl: 0 }}>
                <FFLinearProgress progressValue={parsedValue} />
                <Typography color="primary" fontSize={12} sx={{ flex: '1 0 10%', pl: 1 }}>{val}</Typography>
            </Stack>
        </Stack>

    });

    return (
        <Grid item={true} xs={4} >
            <FFPaper
                sx={{
                    alignItems: 'stretch',
                    position: 'relative',
                    flexDirection: 'row',
                }}
            >
                <KebabMenu
                    menus={defaultMenus}
                    handler={handler}
                />

                <Grid item={true} xs={12} sx={{ display: 'flex', flexDirection: 'column', position: 'relative', pb: 3, pt: 1, pl: 0, pr: 1 }}>


                    <Stack direction="row" spacing={2} sx={{ pr: 4, pl: 2, }}>
                        <Title notooltip={true} big={true}>{t('enroll_quality_score_title')}</Title>

                        <MultipleDropDownMenu multipleLabel='Scores' search={true} label="Quality Metrics" options={['Exposure', 'Sharp Face', 'Resolution', 'Eyes Open']} />
                    </Stack>
                    <Stack direction="column"
                        spacing={4}
                        sx={{
                            pr: 3,
                            pt: 5,
                            pl: 0,
                            maxHeight: '432px',
                            overflowY: 'auto',
                        }}>
                        {itemList}
                    </Stack>

                </Grid>

            </FFPaper>
        </Grid>
    )
}